import ThingsToNote from '../views/FootScan/ThingsToNote.vue';
import Scan from '../views/FootScan/Scan.vue';
import Analyzing from '../views/FootScan/Analyzing.vue';
import ShowResult from '../views/FootScan/ShowResult.vue';

const footScanRoutes = [
  {
    path: '/footscan/things_to_note',
    name: 'FootScan/ThingsToNote',
    component: ThingsToNote,
    props: true,
  },
  {
    path: '/footscan/scan',
    name: 'FootScan/Scan',
    component: Scan,
    props: true,
  },
  {
    path: '/footscan/analyzing',
    name: 'FootScan/Analyzing',
    component: Analyzing,
    props: true,
  },
  {
    path: '/footscan/result',
    name: 'FootScan/ShowResult',
    component: ShowResult,
    props: true,
  },
];

export default footScanRoutes;
